<template>
  <div class="el-input-grid">
    <el-select
      v-close-on-zoom
      :value="selected"
      :placeholder="placeholder"
      :disabled="disabled"
      class="character-select"
      @input="$emit('input', $event)"
    >
      <el-option
        v-for="character in characters"
        :key="character.key"
        :label="character.label"
        :value="character.key"
      />
    </el-select>
    <help-tooltip v-if="warnings.length" type="warning">
      <div v-for="warning in warnings" :key="warning.message">{{ warning.message }}</div>
    </help-tooltip> 
    <help-tooltip v-if="!selected && !errors.length" type="warning">
      <div>An option must be selected. Data will not be saved.</div>
    </help-tooltip> 
    <help-tooltip v-if="errors.length" type="error">
      <div v-for="error in errors" :key="error.message">{{ error.message }}</div>
    </help-tooltip>
  </div>
</template>

<script>

import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

export default {
  name: 'character-select',
  components: {
    HelpTooltip
  },
  props: {
    selected: {
      type: String,
      default: null
    },
    characters: {
      type: Array,
      default: function() { return []; }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select Character'
    },
    errors: {
      type: Array,
      default: function() { return []; }
    },
    warnings: {
      type: Array,
      default: function() { return []; }
    }
  },
};
</script>

<style scoped>
.character-select {
  display: table-cell;
  width: 100%;
}
.el-input-grid {
  display: grid;
  grid-template-columns: 1fr auto;
}
.help-tooltip {
  margin-left: 7px;
  margin-top: 7px;
}
</style>
